import "core-js/modules/es6.string.small";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import times from 'lodash/times';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import MdmParallax from '~/components/atoms/Global/MdmParallax.vue';
import GlobalQuote from '~/components/molecules/Editorial/Global/GlobalQuote.vue';
import CollectionProduct from '~/components/molecules/Editorial/Collection/CollectionProduct.vue';

var EnterAnimate = function EnterAnimate() {
  return import('~/components/atoms/Global/EnterAnimate.vue');
};

export default {
  name: 'CollectionProductsComplementary',
  components: {
    MdmParallax: MdmParallax,
    GlobalQuote: GlobalQuote,
    CollectionProduct: CollectionProduct,
    EnterAnimate: EnterAnimate
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref18, _ref19, _ref20, _ref21, _ref22;

      return {
        background: ((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? _ref22.background_color : _ref22 : _ref22) || '',
        quote: {
          iconColor: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? _ref21.quote_icon_color : _ref21 : _ref21) || '',
          textColor: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.quote_text_color : _ref20 : _ref20) || '',
          paragraph: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.quote_text : _ref19 : _ref19) || '',
          signature: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.quote_signature : _ref18 : _ref18) || ''
        },
        product: times(5, Number).map(function (i) {
          var _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17;

          return {
            withLink: (_ref17 = _this.payload) != null ? (_ref17 = _ref17.items) != null ? (_ref17 = _ref17[i]) != null ? (_ref17 = _ref17.product_url) != null ? _ref17.url : _ref17 : _ref17 : _ref17 : _ref17,
            url: new UrlParse(((_ref16 = _this.payload) != null ? (_ref16 = _ref16.items) != null ? (_ref16 = _ref16[i]) != null ? (_ref16 = _ref16.product_url) != null ? _ref16.url : _ref16 : _ref16 : _ref16 : _ref16) || '').pathname,
            image: {
              small: formatPrismicImage((_ref15 = _this.payload) != null ? (_ref15 = _ref15.items) != null ? (_ref15 = _ref15[i]) != null ? (_ref15 = _ref15.product_image) != null ? (_ref15 = _ref15.small) != null ? _ref15.url : _ref15 : _ref15 : _ref15 : _ref15 : _ref15) || EMPTY_PIXEL,
              medium: formatPrismicImage((_ref14 = _this.payload) != null ? (_ref14 = _ref14.items) != null ? (_ref14 = _ref14[i]) != null ? (_ref14 = _ref14.product_image) != null ? (_ref14 = _ref14.medium) != null ? _ref14.url : _ref14 : _ref14 : _ref14 : _ref14 : _ref14) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref13 = _this.payload) != null ? (_ref13 = _ref13.items) != null ? (_ref13 = _ref13[i]) != null ? (_ref13 = _ref13.product_image) != null ? (_ref13 = _ref13.large) != null ? _ref13.url : _ref13 : _ref13 : _ref13 : _ref13 : _ref13) || EMPTY_PIXEL,
              alt: ((_ref12 = _this.payload) != null ? (_ref12 = _ref12.items) != null ? (_ref12 = _ref12[i]) != null ? _ref12.product_alt : _ref12 : _ref12 : _ref12) || ''
            },
            title: ((_ref11 = _this.payload) != null ? (_ref11 = _ref11.items) != null ? (_ref11 = _ref11[i]) != null ? _ref11.product_title : _ref11 : _ref11 : _ref11) || '',
            price: ((_ref10 = _this.payload) != null ? (_ref10 = _ref10.items) != null ? (_ref10 = _ref10[i]) != null ? _ref10.product_price : _ref10 : _ref10 : _ref10) || '',
            color: ((_ref9 = _this.payload) != null ? (_ref9 = _ref9.items) != null ? (_ref9 = _ref9[i]) != null ? _ref9.product_text_color : _ref9 : _ref9 : _ref9) || ''
          };
        }),
        parallax: {
          offset: 0,
          step: '.collection-products-complementary',
          text: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.parallax_text : _ref8 : _ref8) || '',
          color: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.parallax_text_color : _ref7 : _ref7) || ''
        },
        button: {
          url: new UrlParse(((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.button_url) != null ? _ref6.url : _ref6 : _ref6 : _ref6) || '').pathname,
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.button_text : _ref5 : _ref5) || '',
          negative: this.negative(((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.button_negative : _ref4 : _ref4) || ''),
          tracking: {
            data: {
              event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.button_event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.button_event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.button_event_label : _ref : _ref) || ''
            }
          }
        }
      };
    }
  },
  methods: {
    negative: function negative(arg) {
      var result = false;

      if (arg === 'black') {
        result = true;
      }

      return result;
    }
  }
};